var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDropdown)?_c('div',{class:_vm.arrow,style:(_vm.positioning),attrs:{"id":"item-menu"},on:{"mouseover":_vm.cancelClose,"mouseleave":_vm.debounceClose}},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"pointer-capture"}),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }